import { render, staticRenderFns } from "./NeedHelpItem.vue?vue&type=template&id=fe1aaf80&scoped=true&"
import script from "./NeedHelpItem.vue?vue&type=script&lang=ts&"
export * from "./NeedHelpItem.vue?vue&type=script&lang=ts&"
import style0 from "./NeedHelpItem.vue?vue&type=style&index=0&id=fe1aaf80&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1aaf80",
  null
  
)

export default component.exports